module.exports = __webpack_public_path__ + "img/0002.6f8f8f90.jpg";